module.exports = __webpack_public_path__ + "static/media/patterned_background.9aaeade7.jpg";